export default __webpack_public_path__ + "static/drata-partner-invimatic-banner-8409cb958fb281ab56ea82d0de0cdfc9.jpg";